<div class="page-title-area">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Inicio</a></li>
        <li><a routerLink="/configurar-administracion">Configuración
          Administración</a></li>
        <li><a routerLink="/sedes-listado">Listado de Planes</a></li>
        <li>Nuevo Plan</li>
      </ul>
      <h2>Nuevo Plan</h2>
    </div>
  </div>
</div>

<div class="andorra-apply-content ptb-70  animate__animated animate__fadeIn">
  <div class="container">
    <div class="row mx-auto">
      <div class="col-lg-12 col-md-12">
        <div class="apply-form">
          <form [formGroup]="form" (ngSubmit)="createPlan()">

            <div class="row">

              <div class="col-lg-6 col-md-6 col-sm-12">

                <div class="form-group">
                  <mat-form-field class="example-full-width" appearance="fill" [style.width.%]=100>
                    <mat-label>Identificación</mat-label>
                    <input formControlName="identificacion" type="number" matInput placeholder="Identificacion"
                      [class.is-invalid]="idRefNoValido" autocomplete="off" required>
                    <mat-hint>Código de correlación con GECROS (mapea este plan en el sistema).</mat-hint>
                    <mat-error *ngIf="idRefNoValido">Ingrese identificación de referencia </mat-error>
                  </mat-form-field>
                </div>

              </div>

              <div class="col-lg-6 col-md-6 col-sm-12">

                <div class="form-group">
                  <mat-form-field class="example-full-width" appearance="fill" [style.width.%]=100>
                    <mat-label>Plan</mat-label>
                    <input formControlName="denominacion" matInput placeholder="Plan"
                      [class.is-invalid]="planNoValido" autocomplete="off" required>
                    <mat-error *ngIf="planNoValido">Ingrese un nombre de plan</mat-error>
                  </mat-form-field>
                </div>

              </div>
            </div>

            <h3 class="mt-4 mb-3">Documento del Plan</h3>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <mat-label class="d-block mb-2">Archivo PDF</mat-label>
                  <input
                    class="file-input"
                    type="file"
                    formControlName="pdf"
                    #fileInput
                    accept="application/pdf"
                    (change)="onChangeFile(fileInput.files[0], $event)"
                  />
                  <div *ngIf="file" class="mt-2 text-muted">
                    Archivo seleccionado: {{ fileName }}
                  </div>
                  <div *ngIf="cargandoArchivo" class="progress mt-2">
                    <div class="progress-bar" role="progressbar" [style.width.%]="value">
                      {{ value }}%
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <mat-slide-toggle formControlName="activoDescarga" color="primary">
                    Mostrar PDF
                  </mat-slide-toggle>
                </div>

                <div class="form-group mt-3">
                  <mat-form-field class="example-full-width" appearance="fill" [style.width.%]=100>
                    <mat-label>Leyenda para el usuario</mat-label>
                    <textarea formControlName="leyendaUsuario" matInput placeholder="Leyenda que se mostrará antes del botón de descarga"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <mat-divider class="my-4"></mat-divider>

            <div class="row">
                <div class="col-lg-4 col-md-4">
                  <button type="button" routerLink="/planes-listado"
                    class="btn btn-warning">Cancelar</button>
                </div>

                <div class="col-lg-4 col-md-4">
                  <button [disabled]="!form.valid" type="submit">Guardar</button>
                </div>

              </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>